import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedinIn, FaGithub, FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      id: 0,
      icon: <FaPhone />,
      title: t("contact.phone"),
      value: "+41 77 920 24 63",
      link: "tel:+41779202463",
      linkText: t("contact.callMe"),
    },
    {
      id: 1,
      icon: <FaWhatsapp />,
      title: t("contact.whatsapp"),
      value: t("contact.whatsappMessage"),
      link: "https://wa.me/message/Q47Q2IDMMA2FM1",
      linkText: t("contact.openWhatsapp"),
    },
    {
      id: 2,
      icon: <FaEnvelope />,
      title: t("contact.email"),
      value: "cheveresan_raul@yahoo.com",
      link: "mailto:cheveresan_raul@yahoo.com",
      linkText: t("contact.sendEmail"),
    },
    {
      id: 3,
      icon: <FaMapMarkerAlt />,
      title: t("contact.location"),
      value: t("contact.locationValue"),
      link: null,
      linkText: null,
    },
  ];

  const socialLinks = [
    {
      id: 1,
      icon: <FaGithub />,
      name: t("contact.github"),
      link: "https://github.com/SlickAF31",
    },
    {
      id: 2,
      icon: <FaLinkedinIn />,
      name: t("contact.linkedin"),
      link: "https://www.linkedin.com/in/raul-cheveresan-9a21bb20b/",
    },
  ];

  return (
    <section>
      <div className="border border-border rounded p-4 sm:p-6 md:p-8">
        <h3 className="text-2xl font-semibold text-text mb-6">{t("contact.title")}</h3>

        <div className="space-y-4">
          {contactInfo.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-4 p-4 rounded border border-border hover:border-cyan transition"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded border border-cyan text-cyan text-lg shrink-0">
                {item.icon}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-mono text-xs uppercase tracking-wide text-muted mb-1">
                  {item.title}
                </h4>
                <p className="text-text mb-1 break-words">{item.value}</p>
                {item.link && (
                  <a
                    href={item.link}
                    className="inline-block text-cyan hover:text-text font-medium text-sm transition"
                  >
                    {item.linkText} →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 pt-6 border-t border-border">
          <h4 className="font-mono text-xs uppercase tracking-wide text-muted mb-4">
            {t("contact.connectWithMe")}
          </h4>
          <div className="flex flex-wrap gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 rounded border border-border text-text hover:border-cyan hover:text-cyan transition"
              >
                <span className="text-lg">{social.icon}</span>
                <span className="font-medium text-sm">{social.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
